import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import './RoutingHeader.scss';
import { Link } from 'react-router-dom';
import { RoutingHeaderProps } from '@customTypes/PropTypes';

const RoutingHeader = ({ text = 'Back to Dashboard', goTo = '' } : RoutingHeaderProps):JSX.Element => (
    <div className="w-full h-[63px] text-white font-multipleSans flex justify-center z-10 bg-launch-text border border-solid border-border-light border-l-0 border-r-0">
        <div className="w-full h-[65px] px-4 flex items-center">
            <Link to={goTo} className="flex items-center no-underline text-inherit text-base desktop:pl-2.5">
                <FontAwesomeIcon icon={faChevronLeft} className="back-icon cursor-pointer mr-[15px] text-white text-base" />
                {text}
            </Link>
        </div>
    </div>
);

export default RoutingHeader;
